<template>
  <div>
    <ScrollForMore />
    <img
      class="absolute inset-0 h-auto min-h-eighty w-full object-cover"
      width="2267"
      height="1814"
      src="../../assets/photos/portrait/milan-csizmadia-photography-portrait-lifestyle-budapest-hungary-europe-photographer-freelance-szeged-sunglasses-worldwide-classy-woman.jpg"
      alt="" />
    <div
      class="relative mb-44 h-fifty md:mb-24 md:h-seventy lg:mb-20 lg:h-screen"></div>
    <div class="relative">
      <section class="pb-2 md:pb-4 lg:pb-8">
        <div class="relative h-auto w-full">
          <LazyImgLoader
            :imgClass="'object-cover h-full w-full'"
            :imgSrc="
              require('@/assets/photos/portrait/milan-csizmadia-photography-portrait-lifestyle-budapest-hungary-europe-photographer-freelance-glasses-jeans-worldwide-classy-man-2.jpg')
            "
            :imgWidth="'2046'"
            :imgHeight="'1169'"
            :imgAlt="''" />
          <div
            class="absolute top-0 flex h-full w-full flex-col items-end pr-2 md:pr-4 lg:pr-8">
            <LazyImgLoader
              :imgClass="'flex-1 object-cover h-1/2 w-1/4 -mt-2 md:-mt-4 lg:-mt-8 pb-1 md:pb-2 lg:pb-4'"
              :imgSrc="
                require('@/assets/photos/portrait/milan-csizmadia-photography-portrait-lifestyle-budapest-hungary-europe-photographer-freelance-glasses-jeans-worldwide-classy-man-3.jpg')
              "
              :imgWidth="'781'"
              :imgHeight="'976'"
              :imgAlt="''" />
            <LazyImgLoader
              :imgClass="'flex-1 object-cover h-1/2 w-1/4 -mb-2 md:-mb-4 lg:-mb-8 pt-1 md:pt-2 lg:pt-4'"
              :imgSrc="
                require('@/assets/photos/portrait/milan-csizmadia-photography-portrait-lifestyle-budapest-hungary-europe-photographer-freelance-glasses-jeans-worldwide-classy-man.jpg')
              "
              :imgWidth="'788'"
              :imgHeight="'985'"
              :imgAlt="''" />
          </div>
        </div>
      </section>
      <section class="pt-2 md:pt-4 lg:pt-8">
        <div class="relative h-auto w-full">
          <LazyImgLoader
            :imgClass="'object-contain h-full w-full pl-24 md:pl-48 lg:pl-96'"
            :imgSrc="
              require('@/assets/photos/portrait/milan-csizmadia-photography-portrait-lifestyle-budapest-hungary-europe-photographer-freelance-szeged-worldwide-classy-woman.jpg')
            "
            :imgWidth="'2340'"
            :imgHeight="'1560'"
            :imgAlt="''" />
          <div
            class="absolute top-0 flex h-full w-full flex-col items-start pl-2 md:pl-4 lg:pl-8">
            <LazyImgLoader
              :imgClass="'flex-1 object-cover h-1/2 w-1/2 -mt-2 md:-mt-4 lg:-mt-8 pb-1 md:pb-2 lg:pb-4'"
              :imgSrc="
                require('@/assets/photos/portrait/milan-csizmadia-photography-portrait-lifestyle-budapest-hungary-europe-photographer-freelance-szeged-worldwide-classy-woman-2.jpg')
              "
              :imgWidth="'926'"
              :imgHeight="'617'"
              :imgAlt="''" />
            <LazyImgLoader
              :imgClass="'flex-1 object-cover h-1/2 w-1/2 -mb-2 md:-mb-4 lg:-mb-8 pt-1 md:pt-2 lg:pt-4 z-10'"
              :imgSrc="
                require('@/assets/photos/portrait/milan-csizmadia-photography-portrait-lifestyle-budapest-hungary-europe-photographer-freelance-szeged-boots-worldwide-classy-woman.jpg')
              "
              :imgWidth="'1004'"
              :imgHeight="'669'"
              :imgAlt="''" />
          </div>
        </div>
      </section>
      <section class="">
        <div class="h-auto w-full">
          <LazyImgLoader
            :imgSrc="
              require('@/assets/photos/portrait/milan-csizmadia-photography-portrait-lifestyle-budapest-hungary-europe-photographer-freelance-sunglasses-black-and-white-worldwide-classy-man-2.jpg')
            "
            :imgWidth="'2633'"
            :imgHeight="'1756'"
            :imgAlt="''" />
        </div>
      </section>
      <section class="">
        <div
          class="-my-4 h-auto w-full px-6 md:-my-8 md:px-12 lg:-my-16 lg:px-24">
          <LazyImgLoader
            :imgClass="'relative object-cover shadow-md h-full w-full z-10'"
            :imgSrc="
              require('@/assets/photos/portrait/milan-csizmadia-photography-portrait-lifestyle-budapest-hungary-europe-photographer-freelance-worldwide-classy-girl.jpg')
            "
            :imgWidth="'1782'"
            :imgHeight="'2228'"
            :imgAlt="''" />
        </div>
      </section>
      <section class="">
        <div class="h-auto w-full">
          <LazyImgLoader
            :imgSrc="
              require('@/assets/photos/portrait/milan-csizmadia-photography-portrait-lifestyle-budapest-hungary-europe-photographer-freelance-f1-formula1-esports-mclaren-daniel-bereznay.jpg')
            "
            :imgWidth="'2233'"
            :imgHeight="'1489'"
            :imgAlt="''" />
        </div>
      </section>
      <section class="">
        <div
          class="-my-4 h-auto w-full px-5 md:-my-8 md:px-10 lg:-my-16 lg:px-20">
          <LazyImgLoader
            :imgClass="'object-cover shadow-md h-full w-full'"
            :imgSrc="
              require('@/assets/photos/portrait/milan-csizmadia-photography-portrait-lifestyle-budapest-hungary-europe-photographer-freelance-faceoff-black-and-white-worldwide-bjj-classy-men.jpg')
            "
            :imgWidth="'2112'"
            :imgHeight="'1408'"
            :imgAlt="''" />
        </div>
      </section>
      <section class="-my-4 md:-my-8 lg:-my-16">
        <div
          class="relative z-10 flex h-auto items-center pl-2 md:pl-4 lg:pl-8">
          <div class="flex-1 place-self-stretch pr-1 md:pr-2 lg:pr-4">
            <LazyImgLoader
              :imgClass="'object-cover shadow-md h-full w-full'"
              :imgSrc="
                require('@/assets/photos/portrait/milan-csizmadia-photography-portrait-lifestyle-budapest-hungary-europe-photographer-freelance-faceoff-black-and-white-worldwide-bjj-classy-men-grappling.jpg')
              "
              :imgWidth="'829'"
              :imgHeight="'1036'"
              :imgAlt="''" />
          </div>
          <div class="flex-1 place-self-stretch px-1 md:px-2 lg:px-4">
            <LazyImgLoader
              :imgClass="'object-cover shadow-md h-full w-full'"
              :imgSrc="
                require('@/assets/photos/portrait/milan-csizmadia-photography-portrait-lifestyle-budapest-hungary-europe-photographer-freelance-faceoff-black-and-white-worldwide-bjj-classy-man.jpg')
              "
              :imgWidth="'972'"
              :imgHeight="'1215'"
              :imgAlt="''" />
          </div>
          <div class="h-full w-full flex-2 pl-1 md:pl-2 lg:pl-4">
            <LazyImgLoader
              :imgSrc="
                require('@/assets/photos/portrait/milan-csizmadia-photography-portrait-lifestyle-budapest-hungary-europe-photographer-freelance-faceoff-black-and-white-worldwide-bjj-classy-men-2.jpg')
              "
              :imgWidth="'1500'"
              :imgHeight="'1000'"
              :imgAlt="''" />
          </div>
        </div>
      </section>
      <section class="">
        <div class="relative h-auto w-full">
          <LazyImgLoader
            :imgSrc="
              require('@/assets/photos/portrait/milan-csizmadia-photography-portrait-lifestyle-budapest-hungary-europe-photographer-freelance-szeged-sunglasses-worldwide-classy-woman-2.jpg')
            "
            :imgWidth="'2206'"
            :imgHeight="'1471'"
            :imgAlt="''" />
        </div>
      </section>
      <section class="">
        <div class="relative flex flex-1 items-center p-2 md:p-4 lg:p-8">
          <div class="h-full w-1/2 pr-1 md:pr-2 lg:pr-4">
            <LazyImgLoader
              :imgSrc="
                require('@/assets/photos/portrait/milan-csizmadia-photography-portrait-lifestyle-budapest-hungary-europe-photographer-freelance-wakeboard-worldwide-classy-man.jpg')
              "
              :imgWidth="'1090'"
              :imgHeight="'727'"
              :imgAlt="''" />
          </div>
          <div class="h-full w-1/2 pl-1 md:pl-2 lg:pl-4">
            <LazyImgLoader
              :imgSrc="
                require('@/assets/photos/portrait/milan-csizmadia-photography-portrait-lifestyle-budapest-hungary-europe-photographer-freelance-glasses-studio-worldwide-classy-man.jpg')
              "
              :imgWidth="'1200'"
              :imgHeight="'800'"
              :imgAlt="''" />
          </div>
        </div>
      </section>
      <section class="">
        <div class="h-auto w-full">
          <LazyImgLoader
            :imgSrc="
              require('@/assets/photos/portrait/milan-csizmadia-photography-portrait-lifestyle-budapest-hungary-europe-photographer-freelance-barbershop-black-and-white-worldwide-classy-man-2.jpg')
            "
            :imgWidth="'2496'"
            :imgHeight="'1664'"
            :imgAlt="''" />
        </div>
      </section>
      <section class="">
        <div class="h-auto w-full p-2 md:p-4 lg:p-8">
          <LazyImgLoader
            :imgSrc="
              require('@/assets/photos/portrait/milan-csizmadia-photography-portrait-lifestyle-budapest-hungary-europe-photographer-freelance-body-builder-worldwide-classy-man.jpg')
            "
            :imgWidth="'1946'"
            :imgHeight="'2432'"
            :imgAlt="''" />
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import ScrollForMore from '../../components/ScrollForMore.vue'
import LazyImgLoader from '../../components/LazyImgLoader.vue'

export default {
  name: 'Portrait',
  components: {
    ScrollForMore,
    LazyImgLoader
  }
}
</script>
